import { type StartReapplyRecipesRunMutation } from "~/gql/mutations/produce/reapplyRecipes.generated";
import {
	type GetMyActiveReapplyRecipesRunsQuery,
	type GetReapplyRecipesPreviewQuery,
	type GetReapplyRecipesRunQuery
} from "~/gql/queries/produce/reapplyRecipes.generated";

export const reapplyRecipesEndpoints = {
	GetMyActiveReapplyRecipesRuns: {
		transformResponse: (res: GetMyActiveReapplyRecipesRunsQuery) => res
	},
	GetReapplyRecipesPreview: {
		keepUnusedDataFor: 0,
		transformResponse: (res: GetReapplyRecipesPreviewQuery) => res
	},
	GetReapplyRecipesRun: {
		transformResponse: (res: GetReapplyRecipesRunQuery) => res
	},
	StartReapplyRecipesRun: {
		transformResponse: (res: StartReapplyRecipesRunMutation) => res
	}
};
